import { GridFilterResponse } from '@circlon/operate-api-model';

export class GenericGridFilterResponse<T> extends GridFilterResponse {
  result?: T[];
}
